import React from 'react'
import { Grid } from '@material-ui/core'
import { useTranslations } from 'hooks/useTranslations'
import { IMenuItem } from 'hooks/useMenu'
import { Title } from 'components/ui/Typography/Title'
import { Link } from 'components/ui/Behaviors/Link'
import { NewsletterSubscription } from 'components/ui/Business/NewsletterSubscription'
import { useStyles } from './FooterListGroup.styles'

export interface IFooterListProps {
  footerItem: IMenuItem
}

export const FooterList = ({ footerItem }: IFooterListProps) => {
  const classes = useStyles()
  const t = useTranslations()

  return (
    <Grid item container className={classes.footerMenuColumn} direction={'column'} xs={12} sm={12} lg={2} spacing={2}>
      {footerItem.columnType !== 'newsletterCol' && (
        <Grid item>
          <Title children={footerItem.title} className={classes.title} />
        </Grid>
      )}
      <Grid item container>
        {footerItem.items &&
          footerItem.items.map((subItem, index) => {
            if (footerItem.columnType && footerItem.columnType === 'foundationCol') {
              return (
                <Grid item key={`footer-list-title-sub-item-${index}`} xs={12}>
                  <Link url={subItem.link}>
                    <img alt={subItem.title} className={classes.footerMenuColumnImage} src={`${subItem.imageUrl}`} />
                  </Link>
                </Grid>
              )
            } else if (footerItem.columnType && footerItem.columnType === 'newsletterCol') {
              return <NewsletterSubscription t={t} key={index} />
            } else {
              return (
                <Grid item key={`footer-list-title-sub-item-${index}`} xs={12}>
                  <div className={classes.link}>
                    <Link footer url={subItem.link}>
                      {subItem.title}
                    </Link>
                  </div>
                </Grid>
              )
            }
          })}
      </Grid>
    </Grid>
  )
}
